/* global ksApp */

const searchFilters = () => {
  const form = document.querySelector('.js-search-filters-form');
  const button = document.querySelector('.js-search-filters-button');
  const formElements = form ? Array.from(form.elements) : [];
  const resetLink = document.querySelector('.js-search-filters-clear');
  const userFilters = document.querySelector('.js-search-filters-personalized');
  const dateFrom = document.querySelector('.js-search-filters-date-from');
  const dateTo = document.querySelector('.js-search-filters-date-to');
  let handleForm = true;

  function resetAll() {
    const choosers = form.querySelectorAll('.js-chooser');
    const editButtons = form.querySelectorAll('.js-edit');
    formElements.forEach(element => {
      const field = element;
      if (field.nodeName === 'INPUT') {
        field.value = '';
        field.checked = false;
      }
    });

    Array.from(choosers).forEach(chooser => {
      const saveButton = chooser.querySelector('.js-save');
      if (
        (saveButton && chooser.dataset.chooser === 'industries') ||
        chooser.dataset.chooser === 'countries'
      ) {
        saveButton.click();
      }
    });

    Array.from(editButtons).forEach(item => {
      const sibling = item.previousElementSibling;
      if (sibling) {
        sibling.classList.add('u-hidden');
      }
    });
  }

  function setPersonalizedButtonState(field) {
    const checkbox = field.target;
    const join = ksApp.isSearch ? '&' : '?';
    if (
      checkbox?.value === 'all' &&
      checkbox.classList.contains('js-search-filters-search-match')
    ) {
      resetAll();
      handleForm = false;
      checkbox.checked = true;
      if (resetLink.href.includes(checkbox.name)) {
        button.href = resetLink.href;
      } else {
        button.href = `${resetLink.href}${join}${checkbox.name}=${
          checkbox.value
        }`;
      }
      button.click();
    } else if (
      userFilters?.value !== '' &&
      checkbox.value === 'personalized' &&
      checkbox.classList.contains('js-search-filters-search-match')
    ) {
      let filters = userFilters.value;
      if (ksApp.isSearch) {
        filters = userFilters.value.substr(1);
      }
      handleForm = true;
      button.href = `${resetLink.dataset.reset}${join}${filters}`;
      if (button.href.toString().includes('??')) {
        button.href = button.href.replace('??', '?');
      }
      button.click();
    } else if (
      !checkbox.classList.contains('.js-search-filters-search-match')
    ) {
      const allResults = form.querySelector(
        '.js-search-filters-search-match[value="all"]',
      );

      if (allResults) {
        const allField = form.querySelector(
          `.js-search-filters-filter[name="${allResults.dataset.name}"]`,
        );
        allField.value = allResults.value;
        handleForm = true;
        allResults.checked = true;
      }
    }
  }

  function getFilterNames() {
    const filters = [];
    formElements.forEach(element => {
      if (element.classList.contains('js-search-filters-filter')) {
        filters[element.name] = [];
      }
    });

    return filters;
  }

  function collectData() {
    const filters = getFilterNames();
    formElements.forEach(element => {
      if (
        element.nodeName === 'INPUT' &&
        element.checked &&
        filters[element.dataset.name]
      ) {
        filters[element.dataset.name].push(element.value);
      }
    });

    return filters;
  }

  // Populates data within the hidden fields
  function populateData() {
    const filters = collectData();
    const names = Object.keys(filters);
    names.forEach(name => {
      form.elements[name].value = filters[name].length
        ? filters[name].join()
        : '';
    });
  }

  function getQueryURL(params) {
    const url = new URL(window.location.href);
    const mode = url.searchParams.get('mode');
    let baseURL = window.location.href.toString().split('?')[0];
    const position = baseURL.indexOf('page/');
    if (position > 0 && params.toString() !== url.search.substr(1)) {
      baseURL = baseURL.slice(0, position);
    }

    let fullURL = baseURL;
    if (params.toString()) {
      fullURL = `${baseURL}?${params}`;
      if (mode) {
        fullURL = `${fullURL}&mode=${mode}`;
      }
    } else if (mode) {
      fullURL = `${baseURL}?mode=${mode}`;
    }

    // eslint-disable-next-line no-console
    return fullURL;
  }

  function getCommonParams() {
    const params = new URLSearchParams();

    const searchTerm = form.querySelector('.js-search-filters-query');
    const subject = form.querySelector('.js-search-filters-subject');
    const view = form.querySelector('.js-search-filters-view');
    const sort = form.querySelector('.js-search-filters-sort');

    if (ksApp?.isSearch) {
      params.append('s', searchTerm.value ? searchTerm.value : '');
      params.append('t', subject.value ? subject.value : '');
    } else if (searchTerm?.value) {
      params.append('s', searchTerm.value);
      if (subject?.value) {
        params.append('t', subject.value);
      }
    }

    if (view?.value) {
      params.append('ks_view', view.value);
    }

    if (sort?.value) {
      params.append('ks_sort', sort.value);
    }

    if (dateFrom?.value) {
      params.append('ks_start', dateFrom.value);
    }

    if (dateTo?.value) {
      params.append('ks_end', dateTo.value);
    }

    return params;
  }

  function getParams() {
    let constParams = new URLSearchParams(window.location.search);
    const filters = new URLSearchParams();
    const commonParams = getCommonParams();

    formElements.forEach(element => {
      if (
        element.classList.contains('js-search-filters-filter') &&
        element.value
      ) {
        filters.append(element.name, element.value);
      }
    });

    if (!constParams.toString().includes('ks_adv_')) {
      constParams = new URLSearchParams();
    }

    constParams.forEach((value, key) => {
      if (!key.startsWith('ks_adv_')) {
        constParams.delete(key);
      }
    });

    return new URLSearchParams({
      ...Object.fromEntries(commonParams),
      ...Object.fromEntries(constParams),
      ...Object.fromEntries(filters),
    });
  }

  function setButtonURL() {
    const params = getParams();
    button.href = getQueryURL(params);
  }

  function handleFormChange(event) {
    event.preventDefault();
    setPersonalizedButtonState(event);
    if (handleForm) {
      populateData();
      setButtonURL();
    }
  }

  if (form) {
    form.addEventListener('change', handleFormChange);
  }

  if (button && handleForm) {
    populateData();
    setButtonURL();
  }

  // trigger on load
  const editButton = document.querySelectorAll('.js-edit');
  Array.from(editButton).forEach(btn => {
    const modalName = btn.dataset.chooser;
    const modal = document.querySelector(
      `.js-chooser[data-chooser="${modalName}"]`,
    );
    if (modal) {
      const inputs = modal.querySelectorAll('input:checked');
      const counter = btn.parentElement.querySelector('.js-filter-counter');
      if (inputs.length) {
        counter.parentElement.classList.remove('is-full');
        counter.innerHTML = inputs.length.toString();
      }
    }
  });
  document.querySelectorAll('.js-input-counter-trigger').forEach(field => {
    const counter1 = field.parentElement.parentElement.parentElement.querySelector(
      '.js-filter-counter',
    );
    const number1 = field.parentElement.parentElement.querySelectorAll(
      'input:checked',
    ).length;
    if (counter1) {
      counter1.innerHTML = number1 > 0 ? number1.toString() : '';
    }
    field.addEventListener('change', e => {
      const counter = e.target.parentElement.parentElement.parentElement.querySelector(
        '.js-filter-counter',
      );
      const number = e.target.parentElement.parentElement.querySelectorAll(
        'input:checked',
      ).length;
      if (counter) {
        counter.innerHTML = number > 0 ? number.toString() : '';
      }
    });
  });
};

export default searchFilters;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/searchFilters.js